import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';
import { appendScript } from './append-altapay-script.js';
import { setQuotePaymentMethodAltapay } from '../queries/altapay.graphql.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _empty() {}

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var useGetAltapaySessionData = _ref => {
  function _temp2(e) {
    console.error("Error when fetching session data", e);
    setIsLoading(false);
    setError(true);
  }

  function _client() {
    return _await(client(setQuotePaymentMethodAltapay, {}), _temp);
  }

  function _temp(_ref2) {
    var setQuotePaymentMethod = _ref2.setQuotePaymentMethod;

    if (setQuotePaymentMethod != null && setQuotePaymentMethod.altapay) {
      if (setQuotePaymentMethod.altapay.result === "success") {
        setSessionData({
          sessionId: setQuotePaymentMethod.altapay.sessionId,
          token: setQuotePaymentMethod.altapay.token
        });
        appendScript(scriptURL);
      }
    } else {
      console.log("Could not fetch session data");
      setError(true);
    }

    setIsLoading(false);
  }

  var client = _ref.client,
      isFree = _ref.isFree,
      scriptURL = _ref.scriptURL;

  var _useState = useState({}),
      sessionData = _useState[0],
      setSessionData = _useState[1];

  var _useState2 = useState(true),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(false),
      error = _useState3[0],
      setError = _useState3[1];

  var fetchSessionData = _async(function () {
    return _continueIgnored(_catch(_client, _temp2));
  });

  var reFetchSession = () => {
    setIsLoading(true);
    fetchSessionData();
  };

  useEffect(() => {
    if (isFree) {
      setIsLoading(false);
    } else {
      fetchSessionData();
    }
  }, [isFree]); // eslint-disable-line react-hooks/exhaustive-deps

  return _extends({}, sessionData, {
    isLoading,
    error,
    reFetchSession
  });
};

export { useGetAltapaySessionData };
//# sourceMappingURL=use-get-altapay-session-data.js.map
